module.exports = __webpack_public_path__ + "c7a1ec2268aa309eb91d6abaf666174c.pdf";